import { createAction } from "@reduxjs/toolkit"

export const userLogoutAction = createAction("user/authentication/logout")
